import "./index.css";

function VacinaCounterHeader(props) {
	return (
		<header id="vacina-counter-header">
			<h1 className="ubuntu-font">Estudantes vacinados</h1>
		</header>
	);
}

export default VacinaCounterHeader;